import { WorkspaceEntity } from 'modules/Workspaces/WorkspacesDropdown/utils';

export const getHierarchyDisplayRootWorkspaceId = (
  currentWorkspaceId: string | null,
  workspaces: Record<string, WorkspaceEntity>
): string | null => {
  if (!currentWorkspaceId) return null;

  const currentWorkspace = workspaces[currentWorkspaceId];
  if (!currentWorkspace) return currentWorkspaceId;

  const { parentId } = currentWorkspace;
  if (parentId && workspaces[parentId]) return parentId;

  return currentWorkspaceId;
};
